export function makeData(
  entries: any[],
  rateType: string | undefined
): object[] {
  return [
    ["Rate", `Total ${rateType}/ hour`],
    ...entries.map(entry => [entry.rule, entry.calculatedRate])
  ];
}
